// Only needed when it needs to be loaded before jquery.
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
} 

function headerManager() {
    var lastScrollPos = 0;
    var header = document.querySelector('.header-section');
    
    window.addEventListener("scroll", function () {
        var scrollPos = window.pageYOffset || document.documentElement.scrollTop;

        // Check if user has scrolled more than X amount of PX
        if (scrollPos > 50) {
            if (scrollPos > lastScrollPos) {
                header.classList.add('header-scroll-visability');
            } else {
                header.classList.remove('header-scroll-visability');
            }
        } else {
            // Remove the class if scroll is less than the amount set on line 20
            header.classList.remove('header-scroll-visability');
        }

        lastScrollPos = scrollPos <= 0 ? 0 : scrollPos;
    }, false);
}

docReady(headerManager);